// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import router from './router'
import data from './mock/mock'
import Vuex from 'vuex'
import urls from './scripts/urls.js'
import urlApi from './scripts/urls.js'
import urlReport from './scripts/urls.js'
import urlLogin from './scripts/urlLogin.js'
import VueResource from 'vue-resource'
import ElementUI from 'element-ui'
import $ from 'jquery'
import Swiper from 'swiper'
import IScroll from 'iscroll'
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
import 'element-ui/lib/theme-default/index.css'
import { Button, Select,Table,Dialog,Form,Inpout,Checkbox } from 'element-ui'
global.urls = urls;
global.urlLogin = urlLogin;
global.$ = $;
global.Swiper = Swiper;
global.IScroll = IScroll;
Vue.config.productionTip = false
// console.log(IScroll)
document.addEventListener('touchmove',function(e){e.preventDefault();});


Vue.use(Vuex);
Vue.use(VueResource);
Vue.use(ElementUI);
Vue.component(Button.name, Button)
Vue.component(Select.name, Select)
Vue.component(Dialog.name, Dialog)
Vue.component(Form.name, Checkbox)
Vue.component(Form.name, Form)
Vue.http.options.emulateHTTP = true;
Vue.http.options.emulateJSON = true
/* eslint-disable no-new */
// console.log(Vuex)
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  http: { headers: {'Content-Type': 'application/x-www-form-urlencoded'} }
})
Vue.http.interceptors.push((request, next) => {
  request.method = 'POST';//在请求之前可以进行一些预处理和配置
　　next((response) => {//在响应之后传给then之前对response进行修改和逻辑判断。对于token时候已过期的判断，就添加在此处，页面中任何一次http请求都会先调用此处方法
          if(response.body.code ==500){
            location.href = "/#/"
            localStorage.clear();
          }
  });
});




// WEBPACK FOOTER //
// ./src/main.js